export default "__VITE_ASSET__KtASqI____"